import React from "react";
import {
    List,
    ListProps,
    Datagrid,
    TextField,
    EditButton,
    DeleteButton,
    useTranslate,
    ImageField
} from 'react-admin';

const CategoryList = (props: ListProps) => {
    
    const translate = useTranslate();
    return (
    <List
        {...props}
        sort={{ field: 'name_en', order: 'ASC' }}
        perPage={10}
    >
        <Datagrid rowClick="edit">
            {/* <TextField source="id" hidden={true}/> */}
            <TextField source="id" />
            <TextField source="name_en" />
            <TextField source="name_ar" /> 
            <ImageField source="featured_image" />   
            <EditButton />      
            <DeleteButton />
        </Datagrid>
    </List>
    )
}
export default CategoryList;